import Vue from 'vue';
import http from 'axios';
export default Vue.extend({
    props: {
        name: {
            type: String,
            default: null,
        },
        pages: {
            type: Array,
            default: function () { return []; },
        },
        listClass: {
            type: String,
            default: ''
        },
        itemClass: {
            type: String,
            default: ''
        },
        linkClass: {
            type: String,
            default: ''
        },
        submenuClass: {
            type: String,
            default: ''
        }
    },
    data: function () { return ({
        menu: Array(),
        open: null,
    }); },
    created: function () {
        var _this = this;
        if (this.name) {
            http.get('/api/menu/' + this.name).then(function (res) {
                var menuItems = res.data.items;
                if (menuItems) {
                    _this.menu = menuItems.map(function (item) {
                        item.children = [];
                        return item;
                    });
                }
            });
        }
    },
    mounted: function () {
        var _this = this;
        document.addEventListener('click', function () { return _this.open = null; });
    },
    methods: {
        openMenu: function (item) {
            if (this.open == item) {
                this.open = null;
            }
            else {
                this.open = item;
            }
        }
    },
    watch: {
        pages: {
            handler: function () {
                this.menu = this.pages.map(function (page) {
                    var item = {
                        id: page.id,
                        label: page.localized.title,
                        url: page.localized.external_url || '/' + page.localized.uri.slug,
                        children: page.children
                    };
                    return item;
                });
            },
            immediate: true
        }
    }
});
